// extracted by mini-css-extract-plugin
export default {"ageIconDiv":"age-selector_ageIconDiv__TySTd"};